const LegalSection = ({ title, children }) => (
  <section className="mt-10">
    <h2 className="font-display text-xl font-semibold uppercase tracking-wide text-onsurface">{title}</h2>
    <div className="mt-3 space-y-3 text-sm leading-relaxed text-onsurface2">{children}</div>
  </section>
);

const LegalPage = ({ pageTitle, lastUpdated, sections, testId }) => (
  <main data-testid={testId} className="mx-auto max-w-3xl px-4 pb-24 pt-32 sm:px-6">
    <h1 className="font-display text-4xl font-bold uppercase tracking-wide text-onsurface">{pageTitle}</h1>
    <p className="mt-3 text-sm text-onsurface2">Last updated: {lastUpdated}</p>
    <p className="mt-6 rounded-lg border border-line bg-surface2 p-4 text-xs text-onsurface2">
      Placeholder legal text — replace with your final {pageTitle.toLowerCase()} before launch.
    </p>
    {sections.map((s) => (
      <LegalSection key={s.title} title={s.title}>
        {s.paragraphs.map((p, i) => (
          <p key={i}>{p}</p>
        ))}
      </LegalSection>
    ))}
  </main>
);

export default LegalPage;
